export enum NotificationType {
	Success = 'success',
	Info = 'info',
	Warn = 'warn',
	Error = 'error',
	Secondary = 'secondary',
	Contrast = 'contrast',
}
